/**
 * 포트원 휴대폰 본인 인증을 실행한다.
 */
export function requestCertification(
  params: PortoneCertificationParameter
): Promise<PortoneCertificationResponse> {
  return new Promise<PortoneCertificationResponse>((resolve) => {
    window.IMP.certification(params, resolve);
  });
}
